import { combineReducers } from 'redux';
import { DROPDOWN_STATE_KEY, POPULAR_PLANS_BY_CARRIER_STATE_KEY, FOCUS_COUNTER_KEY } from '../constants';
import { dropdownStateReducer } from './dropdown-state/dropdownStateReducer';
import { scanCardReducer } from './scan-card/scanCardReducer';
import { SCAN_CARD_STATE_KEY } from './scan-card/scanCardConstants';

import {
    POPULAR_CARRIERS_BY_INSURANCE_TYPE_STATE_KEY,
    popularCarriersByInsuranceTypeReducer,
} from './popular-carriers';

import { popularPlansByCarrierReducer } from './popular-plans';
import { CARRIER_STATE_KEY, carrierReducer } from './carrier';
import { INSURANCE_TYPE_STATE_KEY, insuranceTypeReducer } from './insurance-type';
import { PLAN_STATE_KEY, planReducer } from './plan';
import { focusCounterReducer } from './focus';

export const reducers = {
    [DROPDOWN_STATE_KEY]: dropdownStateReducer,
    [POPULAR_CARRIERS_BY_INSURANCE_TYPE_STATE_KEY]: popularCarriersByInsuranceTypeReducer,
    [POPULAR_PLANS_BY_CARRIER_STATE_KEY]: popularPlansByCarrierReducer,
    [CARRIER_STATE_KEY]: carrierReducer,
    [INSURANCE_TYPE_STATE_KEY]: insuranceTypeReducer,
    [PLAN_STATE_KEY]: planReducer,
    [SCAN_CARD_STATE_KEY]: scanCardReducer,
    [FOCUS_COUNTER_KEY]: focusCounterReducer,
};

const insurancePickerReducer = combineReducers(reducers);

export default insurancePickerReducer;
